export default __webpack_public_path__ + "static/flag-dk-70e0354746d76ce7c2743a9a3fb07936.svg";